import { ReactElement } from 'react'
import { PriceBreakModel } from 'interfaces'
import { I18n } from 'common'

import { defaultTheme } from '../../../../../../src/theme/index'
import styled from 'styled-components'

interface PriceBreakProps {
  priceBreak: PriceBreakModel
  updatePriceBreaks: (qty: number) => void
  onClose: () => void
}

export const PriceBreak = (props: PriceBreakProps): ReactElement => {
  const formatPrice = (price: number) => price.toFixed(2)
  const { priceBreak, updatePriceBreaks, onClose } = props

  const handleSelect = () => {
    onClose()
    updatePriceBreaks(priceBreak?.minQty)
  }

  return (
    <Wrapper>
      <Row>
        <Td width="33%" align="right">
          {priceBreak?.minQty}
        </Td>
        <Td align="right" width="34%">{`$${formatPrice(
          priceBreak?.unitCost
        )}`}</Td>
        <ButtonCell width="33%">
          <SelectButton onClick={handleSelect}>
            <I18n name="select" />
          </SelectButton>
        </ButtonCell>
      </Row>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background: #f9f9f7;
  margin-top: 8px;
`
const Row = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`
interface TdProps {
  width?: string
  align?: string
}
const Td = styled.div<TdProps>`
  padding: 19px 12px;
  font-family: Roboto;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  color: #050505;
  mix-blend-mode: normal;
  opacity: 0.9;
  width: ${(p) => p.width};
  text-align: ${(p) => p.align};
`
const ButtonCell = styled.div<{ width?: string }>`
  width: ${(p) => p.width};
  display: flex;
  justify-content: center;
  padding: 12px;
`
const SelectButton = styled.button`
  background-color: ${defaultTheme.colors.warningBackground};
  color: #050505;
  font-family: Oswald;
  font-weight: bold;
  font-size: 16px;
  border: none;
  padding: 8px 20px;
  cursor: pointer;
`
